"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCrossOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M9 4c0-2.191 1.623-2 2.97-2h.032C13.433 2 15 1.809 15 4v2h3c2.155 0 1.901 2 1.901 3.001S20.155 12 18 12h-3v8c0 2.154-2.343 1.797-2.998 1.802C11.347 21.807 9 22.15 9 20v-8H6c-2.112 0-1.901-1.994-1.901-2.999v-.097C4.084 7.874 3.905 6 6 6h3V4zm4 0h-1.999L11 8H6v2h5v10h2V10h5V8h-5V4z' }))); };
exports.default = SvgCrossOutline;
//# sourceMappingURL=CrossOutline.js.map